import configVars from "@/config/config_vars";
let appBaseUrl = configVars.appBaseUrl;

import axios from "axios";

import querystring from "querystring";




/**
 *
 * @param {*} param0
 * @param {*} params
 */
var createUpdateUserOneSignal = (user) => {
    let consulta = `${appBaseUrl}db/user_one_signal`;
    let instance = axios.create();
    instance.defaults.headers.common = {};
    return  instance.post(consulta, user)
      
}




export default {
  createUpdateUserOneSignal
}
